export default {"src":"/_next/static/media/arrow-right-blue.499ef6a8.svg","height":24,"width":24};